class ProductPriceCardView {
  private cardEl: HTMLElement
  private billingCycle: string
  private parent: ProductConfigurationPricingView
  constructor(cardEl: HTMLElement, parent: ProductConfigurationPricingView) {
    this.cardEl = cardEl
    this.parent = parent

    const { billingCycle } = this.cardEl.dataset
    if (!billingCycle) {
      throw new Error(
        'ProductPriceCardView: billingCycle data attribute is null'
      )
    }
    this.billingCycle = billingCycle

    cardEl.addEventListener(
      'click',
      this.handleBillingCycleSelection.bind(this)
    )
  }

  private handleBillingCycleSelection = (e: Event): void => {
    e.preventDefault()
    this.parent.updateBillingCycle(this.billingCycle)
  }

  public updateStyling(billingCycle: string): void {
    const isSelected = billingCycle === this.billingCycle
    if (isSelected) {
      return this.cardEl.classList.add('selected')
    }
    this.cardEl.classList.remove('selected')
  }
}

export class ProductConfigurationPricingView {
  private input: HTMLInputElement
  private priceCards: ProductPriceCardView[] = []

  constructor(el: HTMLElement) {
    const input = el.querySelector<HTMLInputElement>('.js-price-card__input')
    const cardEls = el.querySelectorAll<HTMLElement>(
      '.js-conf-product__price-card'
    )

    if (!input) {
      throw new Error('ProductConfigurationPricingView: input element is null')
    }

    this.input = input

    cardEls.forEach((cardEl) => {
      this.priceCards.push(new ProductPriceCardView(cardEl, this))
    })
  }

  public updateBillingCycle(billingCycle: string): void {
    this.input.value = billingCycle
    this.input.dispatchEvent(
      new Event('change', {
        bubbles: true,
        cancelable: true
      })
    )
    this.priceCards.forEach((card) => card.updateStyling(billingCycle))
  }
}
